/**
 * Function that takes in a currency number and returns it as a formatted currency string.
 *
 * @param value The currency number to format.
 * @param currency The currency code (default is 'USD').
 * @returns The number formatted as a percentage string.
 */
export function formatCurrency({
  value,
  currency = 'USD',
  minimumDecimals = 2,
  maximumDecimals = 4,
}: {
  value: number | undefined | null;
  currency?: string;
  minimumDecimals?: number;
  maximumDecimals?: number;
}) {
  return Number.isFinite(value)
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: minimumDecimals,
        maximumFractionDigits: maximumDecimals,
      }).format(value!)
    : '--';
}

/**
 * Converts a given string to title case, where the first letter of each word is capitalized
 * and the rest of the letters are in lowercase.
 *
 * @param str - The input string to be converted to title case.
 * @returns The input string transformed into title case.
 */
export function toTitleCase(str: string | undefined | null): string {
  if (!str || !str.trim()) {
    return '';
  }

  return str
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
